// extracted by mini-css-extract-plugin
export default {"tooltip":"SecondaryTooltip_tooltip__saxVu","tooltipText":"SecondaryTooltip_tooltipText__o+JLy"};